export const VALIDATION_REG_EXP_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const VALIDATION_REG_EXP_PASSWORD = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&?]{8,16}$/
